import moment from 'moment';
import PropTypes from 'prop-types';
import React, {ComponentClass} from 'react';
import _ from 'underscore';

import * as OnboardingActions from 'actions/OnboardingActions';
import OnboardingConstants from 'constants/OnboardingConstants';
import EntryDAO from 'dao/EntryDAO';
import BaseCreateModal from 'folder-items/BaseCreateModal';
import {FolderDefaultsKey} from 'FolderDefaults';
import {
  REQUEST_FULFILLMENT_DEFINITION_SHAPE,
  RequestFulfillmentDefinition,
} from 'requests/fulfillments/FulfillmentConstants';
import {TagUpdateObject} from 'schemas/tags/TagUtil';
import {StudySearchItem} from 'studies/StudySearchInput';
import * as ModalContainer from 'ui-library/ModalContainer';

const CREATE_ENTRY_MODAL_KEY = 'CreateEntryModal';

interface CreateEntryModalWithOpenProps {
  onEntryCreated?: () => void;
  fulfillments: Array<RequestFulfillmentDefinition>;
  initialDay?: moment.Moment;
  numDays?: number;
  initialFolderId?: string;
  initialStudySearchItems?: Array<StudySearchItem>;
}

export interface CreateEntryModalProps extends CreateEntryModalWithOpenProps {
  onRequestClose: () => void;
  showNotebook?: boolean;
}

export default class CreateEntryModal extends React.Component<CreateEntryModalProps> {
  static propTypes = {
    onEntryCreated: PropTypes.func,
    fulfillments: PropTypes.arrayOf(REQUEST_FULFILLMENT_DEFINITION_SHAPE.isRequired),
  };

  static close(): void {
    ModalContainer.close(CREATE_ENTRY_MODAL_KEY);
  }

  static open(
    modal: ComponentClass<CreateEntryModalProps>,
    props: CreateEntryModalWithOpenProps | null
  ): void {
    if (props == null) {
      props = {fulfillments: []};
    }
    // eslint-disable-next-line no-restricted-syntax
    const modalProps = _.extend({}, {showNotebook: true}, props, {
      onRequestClose(): void {
        ModalContainer.close(CREATE_ENTRY_MODAL_KEY);
      },
    });
    ModalContainer.open(CREATE_ENTRY_MODAL_KEY, React.createElement(modal, modalProps));
  }

  _handleCreateEntry = (
    name: string,
    folderId: string,
    tagSchemaId: string,
    schemaTags: TagUpdateObject,
    studyIds?: Array<string>
  ): JQueryPromise<string> =>
    EntryDAO.create({
      name,
      folder: folderId,
      fulfillments: this.props.fulfillments,
      tagSchemaId,
      schemaTags,
      initialDay: this.props.initialDay,
      numDays: this.props.numDays,
      studyIds,
    })
      .then((resp) => {
        if (this.props.onEntryCreated) {
          this.props.onEntryCreated();
        }
        return resp!.id;
      })
      .done(() => {
        OnboardingActions.completeOnboardingTask(
          OnboardingConstants.MODULES.ENTRY,
          OnboardingConstants.CREATE_ENTRY
        );
      });

  render(): JSX.Element {
    return (
      <BaseCreateModal
        {...this.props}
        title="Create entry"
        create={this._handleCreateEntry}
        folderDefaultsKey={FolderDefaultsKey.NOTEBOOK}
        showInventory={true}
        dataTestAttrs={{component: 'CreateEntryModal', element: 'createButton'}}
      />
    );
  }
}
